import { Injectable, DOCUMENT, inject } from '@angular/core';
import {Meta} from '@angular/platform-browser';
import {environment} from '../../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  private metaService = inject(Meta);
  private document = inject<Document>(DOCUMENT);

  getLogo(): string {
    return environment.theme.logo;
  }

  applyTheme(): void {
    this.setThemeColor();
    this.setFavicon();
    this.setFont();
    this.setIconFont();
  }

  private setThemeColor(): void {
    this.metaService.addTag({
      name: 'theme-color',
      content: environment.theme.primaryColorDarker
    });
  }

  private setFavicon(): void {
    const linkElement: HTMLLinkElement = document.createElement('link');
    linkElement.setAttribute('rel', 'icon');
    linkElement.setAttribute('type', 'image/x-icon');
    linkElement.setAttribute('href', environment.theme.favicon);
    document.head.appendChild(linkElement);
  }

  private setFont(): void {
    const linkElement: HTMLLinkElement = document.createElement('link');
    linkElement.setAttribute('rel', 'stylesheet');
    linkElement.setAttribute('href', environment.theme.font);
    document.head.appendChild(linkElement);
  }

  private setIconFont(): void {
    const linkElement: HTMLLinkElement = document.createElement('link');
    linkElement.setAttribute('rel', 'stylesheet');
    linkElement.setAttribute('href', environment.theme.iconFont);
    document.head.appendChild(linkElement);
  }
}
